import { render, staticRenderFns } from "./ManageRetrieval.vue?vue&type=template&id=10162024"
import script from "./ManageRetrieval.vue?vue&type=script&lang=js"
export * from "./ManageRetrieval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports